"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLEAR_APP_STATE = exports.APP_SHOW_MESSAGE_BAR = exports.APP_LOADING = exports.APP_CLEAR_MESSAGES = exports.APP_CLEAR_LOADING = void 0;
const APP_LOADING = 'app/LOADING';
exports.APP_LOADING = APP_LOADING;
const APP_SHOW_MESSAGE_BAR = 'app/SHOW_MESSAGE_BAR';
exports.APP_SHOW_MESSAGE_BAR = APP_SHOW_MESSAGE_BAR;
const APP_CLEAR_MESSAGES = 'app/CLEAR_MESSAGES';
exports.APP_CLEAR_MESSAGES = APP_CLEAR_MESSAGES;
const APP_CLEAR_LOADING = 'app/CLEAR_LOADING';
exports.APP_CLEAR_LOADING = APP_CLEAR_LOADING;
const CLEAR_APP_STATE = 'app/CLEAR_APP_STATE';
exports.CLEAR_APP_STATE = CLEAR_APP_STATE;
//# sourceMappingURL=index.js.map